import { cn } from '@/shadcn-ui/utils';
import MissingImagePlaceholder from '../missing-image-placeholder';

interface HeroMissingImageProps {
  className?: string;
}

export default function HeroMissingImage({ className }: HeroMissingImageProps) {
  return (
    <div
      className={cn(
        'flex aspect-[4/3] max-h-[800px] flex-row items-center justify-center px-[16px] py-[16px] md:px-0 md:py-[48px]',
        className
      )}
    >
      <div className="h-full w-full">
        <MissingImagePlaceholder />
      </div>
    </div>
  );
}
